import { Item } from 'shared-types';
import { Rate } from '@features/rates/types';

type RateItem = Omit<Item, 'price'> & { price?: Item['price'] };

export function mapRateToItem(rate: Rate): RateItem {
  return {
    id: rate.id,
    name: rate.title,
    image: { url: rate.imageUrl ?? '', externalKey: '' },
    price: rate.price ?? undefined,
  };
}
